<fieldset>
  <legend>
    <nz-badge nzDot [nzShowDot]="this.filtersApplied > 0">
      <span nz-icon nzType="filter" nzTheme="outline"></span>
    </nz-badge>
    Filters
  </legend>
  <div class="filter-panel" [ngStyle]="{ height: (innerContent.clientHeight - 217) + 'px'}">
    <nz-form-item *ngFor="let column of columns">
      <nz-form-label [nzSm]="24" [nzXs]="24" nzNoColon>
        {{column.label}}
      </nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24">
        <ng-container [ngSwitch]="column.filterType">
          <ng-container *ngSwitchCase="'NumberRange'">
            <nz-row nzGutter="16">
              <nz-col nzSm="12">
                <nz-input-number [(ngModel)]="filters[column.name].numberFromValue"
                  (ngModelChange)="applyFilter.emit();" placeholder="from" [ngModelOptions]="{updateOn: 'blur'}">
                </nz-input-number>
              </nz-col>
              <nz-col nzSm="12">
                <nz-input-number nz-input [(ngModel)]="filters[column.name].numberToValue"
                  (ngModelChange)="applyFilter.emit();" placeholder="to" [ngModelOptions]="{updateOn: 'blur'}">
                </nz-input-number>
              </nz-col>
            </nz-row>
          </ng-container>
          <ng-container *ngSwitchCase="'String'">
            <input nz-input [(ngModel)]="filters[column.name].value" (ngModelChange)="applyFilter.emit();"
              [ngModelOptions]="{updateOn: 'blur'}" />
          </ng-container>
        </ng-container>
      </nz-form-control>
    </nz-form-item>
  </div>
</fieldset>
<nz-space>
  <!-- <button *nzSpaceItem nz-button nzType="primary" (click)="applyFilter.emit();">
      <span nz-icon nzType="check" nzTheme="outline"></span>
      Apply Filter
    </button> -->
  <button *nzSpaceItem nz-button (click)="resetFilters.emit();">
    <span nz-icon nzType="clear" nzTheme="outline"></span>
    Reset Filter
  </button>
</nz-space>
